import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";

import { StateContext } from "../../StateContext";
import { VenueContext } from "../../VenueContext";
import DrinkInMenu from "../DrinkInMenu";
import Header from "../Header";
import VenueHome from "../VenueHome";
import WhatsOn from "../WhatsOn";

const SECTIONS = [
  { label: "Home", to: "/bexley" },
  { label: "Drinks", to: "/bexley/drinks" },
];

const Bexley = () => {
  const state = useContext(StateContext);
  const events =
    state.events.past.filter((event) => event.venues.indexOf("Bexley") > -1)
      .length +
    state.events.upcoming.filter((event) => event.venues.indexOf("Bexley") > -1)
      .length;
  const sections =
    events === 0
      ? SECTIONS
      : SECTIONS.concat({ label: "What’s On", to: "/bexley/whats-on" });
  return (
    <VenueContext.Provider value="Bexley">
      <Header sections={sections} />
      <Routes>
        <Route path="/" element={<VenueHome location="bexley" />} />
        <Route path="/drinks/*" element={<DrinkInMenu />} />
        <Route path="/whats-on" element={<WhatsOn />} />
      </Routes>
    </VenueContext.Provider>
  );
};

export default Bexley;
